import styled from 'styled-components';

export const Wrapper = styled.div(
  props => `

.aisAgreementModal{
    display: flex;
    flex-direction: column;
    padding: 32px;
    //width: 650px;
    border-radius: 8px;
    position: absolute;
    z-index: 15;
    background-color: #ffffff;
    //max-height: 670px;
}

.aisAgreementModal ol{
    overflow-y: scroll;
    list-style-type: none;
}

.aisAgreementModal .aisAgreementListItem{
    font-size: 14px;
    display: flex;
    line-height: 20px;
}`,
);
